import React, {useEffect, useState} from "react";
import
  PropTypes
from 'prop-types';
import * as Constants from '../../../components/common/Constants'
import AccountRestrictedService from '../../../services/AccountRestrictedService'
import { Heading, PrimaryButton, RegularText, RegularUnderlinedText, SecondaryButton, SubHeading } from '../input/TextField.styles'
import {MainContainer, MobileViewLogo, SubmitTc, SubmitTcSpan} from './RegistrationLayout.styled';
import { TextField } from '../input';
import { FileUploader } from "../fileUploader/FileUploader";
import Captcha from "../../../components/common/Captcha";
import RegisterService from '../../../services/RegisterService';
import { useSelector } from "react-redux";
import Loader from "../../../components/common/Loader";
import businessLogo from '../../../images/business-logo-dark.svg';
import * as Tagging from '../../../tagging/RegisterFormTagging'
import TermsAndConditions from "../termAndCondition/TermsAndConditions";
import * as ErrorTagging from '../../../tagging/ErrorTagging'


const FormInputToBeClear = ["Business_name", "Work_phone_number", "Job_title", "ID_Passport_number"];
const ERROR_MESSAGE = {
  TECHNICAL_ERROR : 'We’re experiencing technical difficulties. Please try again later.'
};

export const RegistrationLayout = (props) => {

  //TODO separate these values for each field
  const [ infoObj, setInfoObj ] = useState({});
  const [ enableNext, setEnableNext ] = useState(false);
  const [ enableSubmit, setEnableSubmit ] = useState(false);
  const { isCaptchaValidated } = useSelector((state) => ({ isCaptchaValidated: state.isCaptchaValidated }));
  const { captchaResponse } = useSelector((state) => ({ captchaResponse: state.captchaResponse }));
  const [ showLoader, setShowLoader ] = useState(false);
  const [ showTAndC, setShowTAndC ] = useState(false);
  const [ displayView, setDisplayView ] = useState({});
  const [fileData, setFileData] = useState({});
  const [showGsm, setShowGsm] =useState(false);
  const [showMain, setShowMain] =useState(true);
  const [showFixed, setShowFixed] =useState(false);
  const [isGSM, setIsGSM] = useState(false);

  useEffect(()=>{
    if ((infoObj?.First_name?.value && infoObj?.Last_name?.value && infoObj?.Email_address?.value && infoObj?.Cellphone_number?.value &&  infoObj?.Billing_account?.value) &&
    (!infoObj?.First_name?.isError && !infoObj?.Last_name?.isError && !infoObj?.Email_address?.isError && !infoObj?.Cellphone_number?.isError &&  !infoObj?.Billing_account?.isError))
   {
    setEnableNext(true);
   } else {
    setEnableNext(false);
   }

   if ((infoObj?.Business_name?.value && infoObj?.Job_title?.value)
      && (!infoObj?.Business_name?.isError && !infoObj?.Job_title?.isError && !infoObj?.Work_phone_number?.isError)
      && isCaptchaValidated
  ) {
    if (isGSM) {
      if (fileData.validFileType && !infoObj?.ID_Passport_number?.isError && infoObj?.ID_Passport_number?.value.length) {
        setEnableSubmit(true);

      } else {
        setEnableSubmit(false);
      }
      return;
    }
   setEnableSubmit(true);
  } else {
   setEnableSubmit(false);
  }
  },[infoObj, fileData, isCaptchaValidated]);


  useEffect(()=>{
    Tagging.registrationPageLoad();
  }, [])

  useEffect(() => {
    
    if(displayView.currentDisplay === Constants.LOGIN) {
      props.setAccountType(Constants.LOGIN);
    } else {
      props.setAccountType(isGSM ? 'gsm' : 'fixed');
    }
  }, [displayView.currentDisplay, isGSM]);

  useEffect(() => {
    if (showGsm) {
      Tagging.gsmRegistrationPageLoad();
    }
    else if (showFixed) {
      Tagging.fixedRegistrationPageLoad();
    }
  }, [showGsm, showFixed]);

  const setFieldValues = (id, isError, message, value) => {
    setInfoObj((items) => ({
      ...items,
      [id]: {
        isError: isError,
        message: message,
        value: value
      }
    }));
    props.setInfoObj(infoObj);
  }

  const resetForm = () => {

    FormInputToBeClear.forEach(function (inputId) {
      setFieldValues(inputId, undefined, '', undefined);
    })
  }

  const onChange = (e) => {
    props.setDisplay('none');
    let value = e.target.value

    switch (e.target.id) {

        case "First_name":
          if (value.length < 3 && value.length >= 0) {
            setFieldValues(e.target.id, true, 'Please enter a valid first name.', value);
          } else {
            setFieldValues(e.target.id, false, '', value);            
          }
        break;
        case "Last_name":
          if (value.length < 3 && value.length >= 0) {
            setFieldValues(e.target.id, true, 'Please enter a valid last name.', value);
          } else {
            setFieldValues(e.target.id, false, '', value);
          }
        break;
        case "Email_address": 
          if (Constants.EMAIL_REGEX.test(value) && value.match(/@/g).length === 1 && value[value.length - 1] !== ".") {
            setFieldValues(e.target.id, false, '', value);
          }
          else {
            setFieldValues(e.target.id, true, 'Please enter a valid email address.', value);
          }
        break;
        case "Cellphone_number":
          if ((value.length < 21)) {
            setFieldValues(e.target.id, true, 'Please enter a valid cellphone number.', value);
          }
          if (Constants.CELL_NUM_REGEX.test(value) ) {
            setFieldValues(e.target.id, false, '', value);
          }
          if (value.length === 0) {
            setFieldValues(e.target.id, false, '', value);
          }
        break;
        case "Billing_account":
          if (value.length < 3 && value.length >= 0 ) {
            setFieldValues(e.target.id, true, 'Please enter a valid billing account number.', value);
          } else {
            setFieldValues(e.target.id, false, '', value);
          }
        break;
        case "Business_name":
          if (value.length < 3 && value.length >= 0) {
            setFieldValues(e.target.id, true, 'Your business name should be at least 3 characters. ', value);
          } else {
            setFieldValues(e.target.id, false, '', value);
          }
        break;
        case "Work_phone_number":

          if ((value.length < 11) && (value.startsWith("0") === true || value === "")) {
            setFieldValues(e.target.id, true, 'Please enter a valid 10 digit work phone number.', undefined);
          } else if (value.length !== 10 && value.length !== 0){
            setFieldValues(e.target.id, true, 'Please enter a valid 10 digit work phone number.', undefined);
          }
          if(value.length === 0){
            setFieldValues(e.target.id, false, '', undefined);
          }
          if(value.length === 10 && value.startsWith("0") ){
            setFieldValues(e.target.id, false, '', value);
          }
        break;
        case "Job_title":
          if (value.length < 3 && value.length >= 0) {
            setFieldValues(e.target.id, true, 'Your job title should be at least 3 characters.', value);
          } else {
            setFieldValues(e.target.id, false, '', value);
          }
        break;
        case "ID_Passport_number":
          if (value.length < 6 && value.length >= 0) {
            setFieldValues(e.target.id, true, 'Please enter a valid ID/passport number.', value);
          } else {
            setFieldValues(e.target.id, false, '', value);
          }
        break;
      default: break;
    }
  }

  const changeDisplay = (view) => {
    setDisplayView({
      prevDisplay: Constants.REGISTERPART1,
      currentDisplay: view
    })
    props.setDisplayView({
      prevDisplay: Constants.REGISTERPART1,
      currentDisplay: view
    });
  }

  const registerEbuUser = async () => {

    if (isGSM) {
      Tagging.registrationFormSubmit();
    } else {
      Tagging.fixedRegistrationFormComplete();
    }

    setShowLoader(true);
        await RegisterService.registerEbuUser(
        infoObj.First_name?.value,
        infoObj.Last_name?.value,
        infoObj.Email_address?.value,
        infoObj.Cellphone_number?.value,
        infoObj.Work_phone_number?.value,
        infoObj.Business_name?.value,
        infoObj.Job_title?.value,
        infoObj.Billing_account?.value,
        captchaResponse,
        fileData?.name,
        infoObj.ID_Passport_number?.value,
        fileData.file?.fileName,
        fileData.file?.fileBuffer,
        isGSM ? 'gsm' : 'fixed',
        fileData.selectedFile
    ).then((response) => {
        if (response.status === 200) {

          if (isGSM) {
            Tagging.gsmRegistrationSuccess();
          } else {
            Tagging.fixedRegistrationSuccess();
          }
          setShowLoader(false);
          props.setIsSuccess(true)
          props.setRefDetails({refNumber: response.data.result.referenceNumber, submitDate: response.data.result.submitDate})
        }
      }).catch((error) => {
        scrollToTop();
        setShowLoader(false);
        try {
          if (error.response.status === 500) {
            props.setDisplay('flex');
            props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR);
          } else {
            props.setDisplay('flex');
            props.setNotificationText(error.response.data.messages[0].message);
          }
        } catch (ex) {
          props.setDisplay('flex');
          props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR);
          ErrorTagging.registrationTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR)

        }
      })
  }

  const isBusinessAccount = async (accountNo)  => {
    setShowLoader(true);
    await AccountRestrictedService.isBusinessAccount(accountNo)
      .then(res => {
        setShowLoader(false);
        if (res.status === 200 && res.data.result.vodacomAccount) {
          scrollToTop();
          setShowGsm(false);
          setShowMain(false);
          setShowFixed(true);
          setIsGSM(false);
        }else{
          setShowLoader(false);
          setFieldValues('Billing_account', true, 'The account number provided does not exist. Please re-enter the correct billing account number.');
          ErrorTagging.registrationBillingAccountError('The account number provided does not exist. Please re-enter the correct billing account number.');
        }
      }).catch(err => {
        scrollToTop();
        props.setDisplay('flex');
        props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR);
        ErrorTagging.registrationTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR)
        setShowLoader(false);
    })
  }

  const detAccType = async () => {
    setShowLoader(true);
    await AccountRestrictedService.getAccountInfo(infoObj.Billing_account.value).then((response) => {    
        if (response.status === 200) {
          scrollToTop();
          setShowLoader(false);
          if (response.data.result.hasGsmAccess) {
            setShowGsm(true);
            setShowMain(false);
            props.setRegSecondPhase(true);
            setShowFixed(false);
            setIsGSM(true);
          } else if (response.data.result.hasFixedAccess) {
            setShowGsm(false);
            setShowMain(false);
            props.setRegSecondPhase(false);
            setShowFixed(true);
            setIsGSM(false);
          } else {
            isBusinessAccount(infoObj.Billing_account.value);
          }
        } else {
          setShowLoader(false);
          props.setIsError(true);
          setFieldValues('Billing_account', true, 'The account number provided does not exist. Please re-enter the correct billing account number.');
        }
    }).catch((error) => {
      scrollToTop();
      setShowLoader(false);
      props.setDisplay('flex');
      props.setNotificationText(ERROR_MESSAGE.TECHNICAL_ERROR);
      ErrorTagging.registrationTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR)
      
    });
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const validateAccountNumber = () => {
    resetForm();
    Tagging.registrationFormComplete();
    if (infoObj?.Billing_account?.value.length === 8) {
      detAccType();
    } else {
      isBusinessAccount(infoObj?.Billing_account?.value);
    }
  }

  const goToTnC = () => {
    if (showGsm)
      setShowTAndC(true);
    else
      window.open("https://www.vodacombusiness.co.za/business/terms/terms-general-terms-and-conditions", "_blank");
  }

  return (
    <>
    {
    !props.isError &&
      <MainContainer>
        <MobileViewLogo>
          <img width={'100%'} height={props.imageHeight} src={businessLogo} alt="LOGO" />
        </MobileViewLogo>

        <Heading>Create your Business profile</Heading>
        <SubHeading>Your {showMain ? 'personal' : 'business'} information</SubHeading>

        { showLoader && 
          <Loader/>
        }

        {showTAndC ?
            <TermsAndConditions setShowTAndC={setShowTAndC} />
            : null
        }

        {
          (showMain) &&
          <>
            <TextField
              inputLabel={'First name'}
              placeholder={'Enter your first name'}
              onChange={onChange}
              inLineMessage={infoObj?.First_name?.message}
              isError={infoObj?.First_name?.isError}
              value={infoObj?.First_name?.value}
            />
            <TextField
              inputLabel={'Last name'}
              placeholder={'Enter your last name'}
              onChange={onChange}
              inLineMessage={infoObj?.Last_name?.message}
              isError={infoObj?.Last_name?.isError}
              value={infoObj?.Last_name?.value}
            /> 
            <TextField
              inputLabel={'Email address'}
              placeholder={'Enter your email address'}
              onChange={onChange}
              inLineMessage={infoObj?.Email_address?.message}
              isError={infoObj?.Email_address?.isError}
              value={infoObj?.Email_address?.value}
            /> 
            <TextField
              onKeyPress={e => { if ((e.which < 48 || e.which > 57) && e.which !== 43) { e.preventDefault(); } }}
              inputLabel={'Cellphone number'}
              placeholder={'Enter your cellphone number'}
              onChange={onChange}
              inLineMessage={infoObj?.Cellphone_number?.message}
              isError={infoObj?.Cellphone_number?.isError}
              value={infoObj?.Cellphone_number?.value}
              inputType='text'
            /> 
            <TextField
              inputLabel={'Billing account'}
              placeholder={'Enter your billing account'}
              onChange={onChange}
              inLineMessage={infoObj?.Billing_account?.message}
              isError={infoObj?.Billing_account?.isError}
              value={infoObj?.Billing_account?.value}
              toolTipInfo={'Find your billing account number on your monthly statements or invoices.'}
            />
            <PrimaryButton disabled={!enableNext} onClick={validateAccountNumber}>
              Next
            </PrimaryButton>
            <RegularText>
                Already have an account?&nbsp;
              <RegularUnderlinedText onClick={() => {props.setDisplayView({...[], currentDisplay: Constants.LOGIN}); Tagging.loginClickEvent();}}>Log in</RegularUnderlinedText>
            </RegularText>
          </>
        }
        {
            (!showMain) &&
            <>
              <TextField
                  inputLabel={'Business name'}
                  placeholder={'Enter your business name'}
                  onChange={onChange}
                  inLineMessage={infoObj?.Business_name?.message}
                  isError={infoObj?.Business_name?.isError}
                  value={infoObj?.Business_name?.value}
              />
              <TextField
                  onKeyPress={e => { if ((e.which < 48 || e.which > 57) && e.which !== 43) { e.preventDefault(); } }}
                  inputLabel={'Work phone number'}
                  placeholder={'Enter your work phone number'}
                  onChange={onChange}
                  inLineMessage={infoObj?.Work_phone_number?.message}
                  isError={infoObj?.Work_phone_number?.isError}
                  optionalText={'(Optional)'}
                  value={infoObj?.Work_phone_number?.value}
              />
              <TextField
                  inputLabel={'Job title'}
                  placeholder={'Enter your job title'}
                  onChange={onChange}
                  inLineMessage={infoObj?.Job_title?.message}
                  isError={infoObj?.Job_title?.isError}
                  value={infoObj?.Job_title?.value}
              />
              {
                  showGsm &&

                  <>
                    <TextField
                        inputLabel={'ID/Passport number'}
                        placeholder={'Enter your ID/passport number'}
                        onChange={onChange}
                        inLineMessage={infoObj?.ID_Passport_number?.message}
                        isError={infoObj?.ID_Passport_number?.isError}
                        value={infoObj?.ID_Passport_number?.value}
                    />
                    <FileUploader uploadLabel={'Upload copy of ID/Passport'} fileData={fileData}
                                  setFileData={setFileData}/>
                  </>
              }
              <Captcha/>
              <SubmitTc className="submitTC">By selecting ‘Submit’ you agree to the <SubmitTcSpan onClick={() => goToTnC() }>terms and conditions</SubmitTcSpan></SubmitTc>
              <div style={{
                'display': 'flex',
                'justifyContent': 'center',
                'alignItems': 'center',
                'gap': '16px',
                'alignSelf': 'stretch'
              }}>
                <SecondaryButton onClick={() => {

                  setShowGsm(false);
                  setShowMain(true);
                  setShowFixed(false);
                  setIsGSM(false);
                  props.setRegSecondPhase(false);

                  if (isGSM) {
                    Tagging.gsmRegistrationNavigateBack();
                  } else {
                    Tagging.fixedRegistrationNavigateBack();
                  }
                }
                }>Go back</SecondaryButton>
                <PrimaryButton disabled={!enableSubmit} onClick={registerEbuUser}>Submit</PrimaryButton>
              </div>
              <RegularText>
                Already have an account?&nbsp;
                <RegularUnderlinedText onClick={() => props.setDisplayView({...[], currentDisplay: Constants.LOGIN})}>Log
                  in</RegularUnderlinedText>
              </RegularText>
            </>
        }
      </MainContainer>
    }
    </>
  );
};

RegistrationLayout.propTypes = {
  infoObj: PropTypes.object,
  setInfoObj: PropTypes.func,
  displayView: PropTypes.string,
  setDisplayView: PropTypes.func,
  refDetails: PropTypes.object,
  setRefDetails: PropTypes.func,
  setAccountType: PropTypes.func,
  accountType: PropTypes.string,
  isError: PropTypes.bool,
  setIsError: PropTypes.func,
  setIsSuccess: PropTypes.func,
  isSuccess: PropTypes.bool
};

RegistrationLayout.defaultProps = {
  infoObj: {},
  setInfoObj: ()=>{},
  displayView: '',
  setDisplayView: ()=>{},
  refDetails: {},
  setRefDetails: ()=>{},
  setAccountType: ()=>{},
  accountType: '',
  isError: false,
  setIsError: ()=>{},
  setIsSuccess: ()=>{},
  isSuccess: false,
};
